import { useQuery } from '@tanstack/react-query';
import { refereeAppService } from '../services/referee-app.service';
import type { RefereeVerificationInfo } from '../types/referee-app.types';

export function useRefereeVerificationInfo(shareId: string): {
  data: RefereeVerificationInfo | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
} {
  const query = useQuery({
    queryKey: ['referee-verification', shareId],
    queryFn: () => refereeAppService.getRefereeVerificationInfo(shareId),
    enabled: !!shareId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
